import { useEffect } from 'react';

export default function useMutationObserver(
  target,
  callback,
  options = {
    childList: true,
    characterData: true,
    attributes: true,
    subtree: true,
  }
) {
  useEffect(() => {
    if (!target?.current) {
      return undefined;
    }
    const observer = new MutationObserver(callback);
    observer.observe(target.current, options);
    return () => observer.disconnect();
  }, [callback, options, target]);
}
